import { ordersConstants, siteConstants } from "../../constants";
import { ordersServices } from "../../services";
import { alertActions } from ".";

const listOrders = (startDate, endDate) => {
  const request = (startDate, endDate) => {
    return {
      type: ordersConstants.LIST_ORDERS_REQUEST,
      payload: {
        startDate,
        endDate,
      },
    };
  }

  const success = (data) => {
    return {
      type: ordersConstants.LIST_ORDERS_SUCCESS,
      payload: { data },
    };
  }

  const failure = () => {
    return {
      type: ordersConstants.LIST_ORDERS_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request(startDate, endDate));
    ordersServices.listOrders(startDate, endDate)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure());
      });
  };
}

const retrieveOrder = (orderId) => {
  const request = (orderId) => {
    return {
      type: ordersConstants.RETRIEVE_ORDER_REQUEST,
      payload: { orderId },
    };
  }

  const success = (data) => {
    return {
      type: ordersConstants.RETRIEVE_ORDER_SUCCESS,
      payload: { data },
    };
  }

  const failure = () => {
    return {
      type: ordersConstants.RETRIEVE_ORDER_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request(orderId));
    ordersServices.retrieveOrder(orderId)
      .then(response => {
        const data = response.data
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure());
      });
  };
}

export const ordersActions = {
  listOrders,
  retrieveOrder,
};